// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'document-compress';

export const Component = () => (
  <path d='M22.205 6.753 15.452 0H4.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 3 1.485v21.552c0 .431.144.766.431 1.054.288.287.623.43 1.054.43h16.667c.43 0 .766-.143 1.053-.43.288-.288.432-.623.432-1.054V7.807c0-.431-.144-.814-.432-1.054ZM15.74 1.677l5.173 5.172h-4.646c-.335 0-.479-.144-.479-.479l-.047-4.693h-.001Zm5.939 6.178v15.182c0 .335-.191.479-.527.479H12.82V21.6h-1.964v1.916h-6.37c-.334 0-.478-.144-.478-.48V1.487c0-.336.144-.527.479-.527h10.297v5.41c0 .432.144.767.431 1.054.288.288.623.431 1.054.431h5.412-.001Zm-10.824 9.818h1.963v1.963h-1.963v-1.963Zm3.927 1.963v1.963h-1.963v-1.963h1.963Zm-3.927-5.89h1.963v1.963h-1.963v-1.964Zm3.927 1.963v1.963h-1.963v-1.963h1.963Z' />
);

export const viewBox = '0 0 25 25';
